export default "__VITE_ASSET__ClXNndhH__"